<template>
  <span>
    <v-list-tile
      :to="to"
      active-class=""
      :class="
        highContrast ? 'dark' : to != $route.path ? 'accent' : 'highlight-item'
      "
    >
      <v-list-tile-action>
        <v-icon
          :color="highContrast ? 'dark' : 'primary'"
          v-if="icon && !icon.includes('ico_')"
          >{{ icon }}</v-icon
        >
        <v-img
          :src="require('../assets/icons/' + icon + '.svg')"
          contain
          height="24"
          width="24"
          max-width="56"
          position="left"
          v-if="icon && icon.includes('ico_')"
          class="ml-3"
        ></v-img>
      </v-list-tile-action>

      <v-list-tile-content>
        <v-list-tile-title :class="{ 'primary--text': !highContrast }">{{
          title
        }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </span>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapState } = createNamespacedHelpers("portal");

export default {
  name: "ItemMenu",
  props: {
    to: [String, Object],
    icon: String,
    title: String
  },
  computed: mapState(["highContrast"])
};
</script>

<style scoped>
.highlight-item {
  background-color: #dbdbdb;
}
</style>
